<template>
    <div
        class="pt-16 pb-10 bg-cover bg-blue-dark"
        :style="{
            backgroundImage: `url(${backgroundImage})`,
            backgroundColor
        }"
    >
        <h2 class="font-primary text-4xl text-white text-center text-white">
            {{ $config("PERSONAJES") }}
        </h2>

        <slider :items="characters" :options="sliderOptions">
            <template v-slot="{ item: character }">
                <div
                    class="flex flex-col items-center w-10/12 mx-auto"
                    :style="{ maxWidth: '250px' }"
                >
                    <div
                        class="relative w-32 sm:w-40 h-32 sm:h-40 rounded-full border-4 mb-12"
                        :style="characterStyles"
                    >
                        <app-image
                            :url="character.img"
                            class="absolute max-w-none"
                            :style="{ width: '120%', left: '-10%' }"
                            lazy
                            no-placeholder
                        ></app-image>
                    </div>

                    <span class="font-secondary text-2xl text-white">{{
                        character.nombre
                    }}</span>
                </div>
            </template>
        </slider>
    </div>
</template>

<script>
import Slider from "./Slider";

export default {
    name: "serie-characters-slider",

    components: { Slider },

    props: {
        characters: {
            type: Array,
            default: () => []
        },

        backgroundImage: {
            type: String,
            required: true
        },

        backgroundColor: {
            type: String,
            required: true
        },

        characterCustomStyles: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },

    data() {
        return {
            sliderOptions: {
                slidesPerView: 2,
                breakpoints: {
                    576: {
                        slidesPerView: 3
                    },
                    768: {
                        slidesPerView: 4
                    }
                }
            }
        };
    },

    computed: {
        characterStyles() {
            let styles = {
                backgroundColor: "transparent",
                borderColor: "white"
            };

            Object.entries(this.characterCustomStyles).forEach(
                ([key, value]) => {
                    if (value) styles[key] = value;
                }
            );

            return styles;
        }
    }
};
</script>
